// settings for header
export const headerHamburger = () => {
  const hamburger = document.querySelector('.js-header-menu-button');
  const header = document.querySelector('.js-header');

  if (!hamburger || !header) return;

  let isOpen = false;

  hamburger.addEventListener('click', () => {
    isOpen = !isOpen;

    if (window.innerWidth > 1080) return;

    if (isOpen) {
      hamburger.classList.add('is-open');
      header.classList.add('is-open');
    } else {
      hamburger.classList.remove('is-open');
      header.classList.remove('is-open');
    }
  });

  document.addEventListener('click', (e: any) => {
    if (window.innerWidth > 1080) return;
    if (!hamburger.contains(e.target) && !header.contains(e.target)) {
      isOpen = false;
      hamburger.classList.remove('is-open');
      header.classList.remove('is-open');
    }
  });
};
